import React from "react";
import { Select } from "antd";

export const PageSizeSelector = ({ selectedPageSize, setSelectedPageSize }) => (
    <Select
        style={{ width: 150 }}
        placeholder="Items per page"
        value={selectedPageSize}
        onChange={(value) => {
            setSelectedPageSize(value);
        }}
        options={[
            { label: "5 items", value: 5 },
            { label: "10 items", value: 10 },
            { label: "30 items", value: 30 },
            { label: "50 items", value: 50 },
            { label: "100 items", value: 100 },
        ]}
        size="small"
    />
);
